export enum TranslationLanguagesEnum {
	POLISH = 'pl',
	ENGLISH = 'en',
	GERMAN = 'de',
}
